import { defineComponent as s, computed as a } from "vue";
import { isNull as p, isUndefined as u } from "lodash-es";
const r = /* @__PURE__ */ s({
  __name: "dropdown-item-content",
  props: {
    label: { default: "" },
    count: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    breakText: { type: Boolean }
  },
  setup(o, { expose: n }) {
    const e = o, t = a(() => !p(e.count) && !u(e.count));
    return n({ hasCount: t }), { __sfc: !0, props: e, hasCount: t };
  }
});
export {
  r as default
};
